'use client';

import Image from 'next/image';
import { usePathname } from 'next/navigation';
import { AssetStoryblok } from '@/types/types-storyblok';
import Link from 'next/link';
import { getImageDimension } from '@/storyblok/utils/getImageDimension';
import { DAVINCI_CDN } from '@/costants/defaultValues';

const HeaderLogo = ({ logo }: { logo?: AssetStoryblok }) => {
  const pathName = usePathname();
  return (
    <Link aria-current={pathName === '/' ? 'page' : undefined} href="/">
      <Image
        className="relative top-1"
        src={logo?.filename ?? `${DAVINCI_CDN}/elty/elty-logo.svg`}
        alt={logo?.alt ?? 'Elty logo'}
        {...(logo ? getImageDimension(logo) : { width: 108, height: 33 })}
      />
    </Link>
  );
};

export default HeaderLogo;
